<template>
  <div class="w-full">
    <div class="bg-white border min-h-[260px] border-gray-300 relative p-4">
      <div
        class="pt-3 pb-1.5 border-b border-b-gray-200 border-dashed flex items-center gap-3 relative"
      >
        <label
          for="email"
          class="font-normal w-28 text-gray-400 text-[14px] required"
          >Email
        </label>
        <input
          type="text"
          id="email"
          v-model="qrcreate.email.email"
          class="h-[22px] border-none shadow-none placeholder-gray-300 outline-none focus:outline-none w-full"
        />
      </div>
      <div
        class="pt-3 pb-1.5 border-b border-b-gray-200 border-dashed flex items-center gap-3 relative"
      >
        <label for="subject" class="font-normal w-28 text-gray-400 text-[14px]"
          >{{ $t("subject") }}
        </label>
        <input
          type="text"
          id="subject"
          v-model="qrcreate.email.subject"
          class="h-[22px] border-none shadow-none placeholder-gray-300 outline-none focus:outline-none w-full"
        />
      </div>
      <div
        class="pt-3 pb-1.5 border-b border-b-gray-200 border-dashed flex gap-3 relative"
      >
        <label for="message" class="font-normal w-28 text-gray-400 text-[14px]"
          >{{ $t("message") }}
        </label>
        <textarea
          type="text"
          id="message"
          v-model="qrcreate.email.message"
          class="min-h-[22px] border-none shadow-none placeholder-gray-300 outline-none focus:outline-none w-full"
        />
      </div>
    </div>
    <ToolsButtonCreate @generate="generate" />
  </div>
</template>
<script lang="ts" setup>
import { useQrCreateStore } from "~/stores/qrcreate";

const error = ref(false);
const qrcreate = useQrCreateStore();
const qrstyle = useQrStyle();
const validateData = () => {
  if (qrcreate.email.email) {
    return true;
  }
  error.value = true;
  return false;
};
const generate = async () => {
  if (validateData()) {
    await qrstyle.GenerateQrCode({ stack: true });
  }
};
</script>
